import { useEffect, useState } from 'react';
// import './cadastroPF.css';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../../../assets/css/custom-toast.css';
import CheckboxGroup from '../../../components/form/CheckboxGroup';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCadastroComIcone from '../../../components/form/InputCadastroComIcone';
import InputCelularEstrangeiro from '../../../components/form/InputCelularEstrangeiro';
import InputCpf from '../../../components/form/InputCpf';
import InputNomeCompleto from '../../../components/form/InputNomeCompleto';
import InputSenha from '../../../components/form/InputSenha';
import SelectGenero from '../../../components/form/SelectGenero';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { IDCORREIOS_PESQUISA } from '../../../services/cadastro';
import { createFormSchemas } from './FormSchema';

const FormCadastroPFEstrangeiro = ({ onSubmit, data }) => {
  const { t } = useTranslation();
  const { formSchemaCadastroEstrangeiro } = createFormSchemas(t);
  const methods = useForm({
    resolver: yupResolver(formSchemaCadastroEstrangeiro),
  });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const { request: requestMeuCorreios, data: dadosCPF } = useFetch();
  const { request: requestRFB, data: dadosRFB } = useFetch();
  //const [desabilitarCampo, setDesabilitarCampo] = useState(true);
  const [desabilitarCampoMae, setDesabilitarCampoMae] = useState(false);
  const [desabilitarSalvar, setDesabilitarSalvar] = useState(true);
  //const { request: requestNecessidades, data: listaNecessidades } = useFetch();

  const [residencia, setResidencia] = useState('1');
  const handleResidencia = (event) => {
    setResidencia(event.target.value);
  };
  const [tenhoCpf, setTenhoCpf] = useState('1');

  const handleTenhoCpf = (event) => {
    setTenhoCpf(event.target.value);
    if (event.target.value === '1') {
      //setDesabilitarCampo(true);
      //setDesabilitarCampoMae(true);
    } else {
      abreAlertaDialog(
        t('cadastro.messages.info.no_cpf_warning', {
          defaultValue:
            'Caro Cliente, Sem a informação de CPF no cadastro, o usuário fica impossibilitado a acessar alguns dos nossos serviços e a emissão do boleto bancário.',
        }),
      );
      //setDesabilitarCampo(false);
      //setDesabilitarCampoMae(false);
    }
  };
  const [isCheckedNomeMaeDesconhecido, setIsCheckedNomeMaeDesconhecido] =
    useState(false);
  const [nomeMae, setNomeMae] = useState();
  const handleNomeMaeDesconhecido = () => {
    setIsCheckedNomeMaeDesconhecido(!isCheckedNomeMaeDesconhecido);
  };
  useEffect(() => {
    if (!isCheckedNomeMaeDesconhecido) {
      setDesabilitarCampoMae(false);
    } else {
      document.getElementById('nomeDaMae').value = '';
      setDesabilitarCampoMae(true);
    }
  }, [isCheckedNomeMaeDesconhecido]);

  const [meioEnvio, setMeioEnvio] = useState('E');
  const handleMeioEnvio = (event) => {
    setMeioEnvio(event.target.value);
  };
  const handleReset = () => {
    //setDesabilitarCampo(true);
    //setDesabilitarCampoMae(true);
    const form = document.getElementById('formCadastro');
    const campos = form.querySelectorAll('input, select');
    campos.forEach((campo) => {
      campo.value = '';
    });
    setTenhoCpf('1');
    setResidencia('1');
  };
  const [ddi, setDdi] = useState();
  const atribuirDDI = (event) => {
    setDdi(event.target.value);
  };

  const [isCheckedTermo, setIsCheckedTermo] = useState(false);
  const handleTermo = () => {
    setIsCheckedTermo(!isCheckedTermo);
    if (!isCheckedTermo) {
      setDesabilitarSalvar(false);
    } else {
      setDesabilitarSalvar(true);
    }
  };

  const navigate = useNavigate();
  function handleSubmit(data) {
    if (!isCheckedTermo) {
      abreAlertaDialog(t('cadastro.messages.validation.terms_required'));
    } else {
      let nomeDaMae = data.nomeDaMae;
      if (isCheckedNomeMaeDesconhecido) {
        nomeDaMae = t('cadastro.forms.labels.unknown_mother', {
          defaultValue: 'MAE DESCONHECIDA',
        });
      }
      const telefoneFormatado = data.foneMovel.replace(/[\(\)\-\s]/g, '');
      var tipoEstrangeiro = 'B';
      var idCorreios;
      var cpf;
      if (data.residencia === '0') {
        tipoEstrangeiro = 'E';
      }
      if (data.tenhoCpf === '1') {
        cpf = data.cpf.replace(/[.-]/g, '');
        //setCPF(data.cpf.replace(/[.-]/g, ''));
        idCorreios = cpf;
      } else {
        idCorreios = data.inputLogin.toLowerCase();
      }
      var genero = 'N';
      if (data.genero) {
        genero = data.genero;
      }
      const dataNasc = new Date(data.dataNascimento);
      const yyyy = dataNasc.getFullYear();
      const mm = String(dataNasc.getMonth() + 1).padStart(2, '0');
      const dd = String(dataNasc.getDate()).padStart(2, '0');
      const formattedDate = `${yyyy}-${mm}-${dd}`;
      const dadosCompletoEstrangeiro = {
        cie: data.identidadePassaporte,
        cpf: cpf,
        sexo: genero,
        dataNascimento: formattedDate,
        nomeDaMae: nomeDaMae,
        idCorreios: idCorreios,
        tipoEstrangeiro: tipoEstrangeiro,
        foneMovel: telefoneFormatado,
        dddMovel: data.dddMovel,
        ddiMovel: data.ddiMovel,
        tipo: 'PF',
        termoAceito: 'S',
        nome: data.nome.trim().toUpperCase(),
        senha: data.senha,
        email: data.email,
        meioEnvio: meioEnvio,
        situacaoAtual: 'P',
        necessidadesEspeciais: data.necessidadesEspeciais,
      };
      onSubmit(dadosCompletoEstrangeiro);
    }
  }
  useEffect(() => {
    if (
      typeof dadosRFB != 'undefined' &&
      dadosRFB?.situacao != '0' &&
      dadosRFB?.situacao != '4' &&
      dadosRFB?.regular
    ) {
      toast(
        ({ closeToast }) => (
          <div className="custom-toast">
            <img
              alt="imagem de perfil da carol, assistente virtual dos correios"
              id="img-carol-boasvindas"
              src="/images/carol-perfil.png"
            />
            <p style={{ textAlign: 'justify' }}>
              Caro Cliente, não foi possível realizar seu cadastro. É necessário
              regularizar a situação cadastral junto à Receita Federal do
              Brasil. Para consultar, busque no site da Receita Federal do
              Brasil:
              <br />
              <a
                className="txt-link"
                href="https://cav.receita.fazenda.gov.br/autenticacao/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                cav.receita.fazenda.gov.br/autenticacao/login
              </a>
              <br />e tente novamente.
            </p>
            <button
              onClick={() => {
                closeToast();
                //navigate('/login');
              }}
            >
              OK
            </button>
          </div>
        ),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false, // Isso impede que o toast feche automaticamente
          closeOnClick: false, // Isso impede que o toast feche ao clicar
          closeButton: false,
        },
      );
    } else {
      if (typeof dadosRFB != 'undefined' && !dadosRFB?.regular && dadosRFB) {
        toast(
          ({ closeToast }) => (
            <div className="custom-toast">
              <p style={{ textAlign: 'justify' }}>
                Cliente Correios, não foi possível realizar seu cadastro. CPF
                inexistente na base de dados da Receita Federal do Brasil. Para
                consultar, busque no site da Receita Federal do Brasil:
                <br />
                <a
                  href="https://cav.receita.fazenda.gov.br/autenticacao/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: '12px', fontWeigh: 'bold' }}
                >
                  cav.receita.fazenda.gov.br/autenticacao/login
                </a>
                <br />e tente novamente.
              </p>
              <button
                onClick={() => {
                  closeToast();
                  navigate('/login');
                }}
              >
                OK
              </button>
            </div>
          ),
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false, // Isso impede que o toast feche automaticamente
            closeOnClick: false, // Isso impede que o toast feche ao clicar
            closeButton: false,
          },
        );
      } else {
        if (typeof dadosRFB != 'undefined' && dadosRFB) {
          requestMeuCorreios(IDCORREIOS_PESQUISA(CPF));
        }
      }
    }
  }, [dadosRFB]);

  const listaNecessidades = [
    {
      id: 1,
      descricao: t('cadastro.forms.options.special_needs.physical', {
        defaultValue: 'Física',
      }),
    },
    {
      id: 2,
      descricao: t('cadastro.forms.options.special_needs.visual', {
        defaultValue: 'Visual',
      }),
    },
    {
      id: 3,
      descricao: t('cadastro.forms.options.special_needs.intellectual', {
        defaultValue: 'Intelectual',
      }),
    },
    {
      id: 4,
      descricao: t('cadastro.forms.options.special_needs.auditory', {
        defaultValue: 'Auditiva',
      }),
    },
    {
      id: 5,
      descricao: t('cadastro.forms.options.special_needs.psychosocial', {
        defaultValue: 'Psicossocial',
      }),
    },
    {
      id: 6,
      descricao: t('cadastro.forms.options.special_needs.multiple', {
        defaultValue: 'Múltipla',
      }),
    },
    {
      id: 7,
      descricao: t('cadastro.forms.options.special_needs.others', {
        defaultValue: 'Outras',
      }),
    },
  ];
  useEffect(() => {
    //  requestNecessidades(LISTAR_NECESSIDADES_ESPECIAIS());
    if (typeof dadosCPF === 'undefined' || dadosCPF == null) {
      //setDesabilitarCampo(true);
      //setDesabilitarCampoMae(true);
    } else {
      //setDesabilitarCampo(false);
      //setDesabilitarCampoMae(false);
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [dadosCPF]);

  return (
    <>
      <form id="formCadastro" onSubmit={methods.handleSubmit(handleSubmit)}>
        <div className="controle">
          <div className="residencia">
            <label className="radio">
              <Input
                type="radio"
                id="residencia-brasil"
                name="residencia"
                value="1"
                checked={residencia === '1'}
                onChange={handleResidencia}
                {...formMethods}
              />
              <div className="subtitulo-p">
                {t('cadastro.forms.options.resident_brazil')}
              </div>
            </label>

            <label className="radio">
              <Input
                type="radio"
                id="residencia-exterior"
                name="residencia"
                value="0"
                checked={residencia === '0'}
                onChange={handleResidencia}
                {...formMethods}
              />
              <div className="subtitulo-p">
                {t('cadastro.forms.options.resident_abroad')}
              </div>
            </label>
          </div>
        </div>

        <hr />

        <InputCadastro
          type="text"
          id="identidadePassaporte"
          name="identidadePassaporte"
          placeholder=""
          maxLength="20"
          label={t('cadastro.forms.labels.id_passport')}
          {...formMethods}
        />
        <div className="tem-cpf">
          <label className="radio">
            <Input
              type="radio"
              id="tenhoCpf"
              name="tenhoCpf"
              value="1"
              checked={tenhoCpf === '1'}
              onChange={handleTenhoCpf}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.have_cpf')}
            </div>
          </label>

          <label className="radio">
            <Input
              type="radio"
              id="naoTenhoCpf"
              name="tenhoCpf"
              value="0"
              checked={tenhoCpf === '0'}
              onChange={handleTenhoCpf}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.no_cpf')}
            </div>
          </label>
        </div>
        {tenhoCpf === '1' ? (
          <InputCpf
            label={t('cadastro.forms.labels.cpf')}
            type="text"
            id="cpf"
            name="cpf"
            //onBlur={handleCPF}
            {...formMethods}
          />
        ) : (
          <InputCadastro
            type="text"
            id="inputLogin"
            name="inputLogin"
            placeholder=""
            maxLength="15"
            label={t('cadastro.forms.labels.create_username_detailed', {
              defaultValue:
                'Crie seu usuário* (Entre 10 e 15 caracteres, com letras e números)',
            })}
            {...formMethods}
          />
        )}
        <InputNomeCompleto
          type="text"
          id="nome"
          name="nome"
          placeholder=""
          label={t('cadastro.forms.labels.full_name')}
          maxLength="150"
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        {tenhoCpf === '1' && (
          <>
            <InputNomeCompleto
              type="text"
              id="nomeDaMae"
              name="nomeDaMae"
              label={t('cadastro.forms.labels.mothers_name')}
              placeholder=""
              {...formMethods}
              disabled={desabilitarCampoMae}
            />
            <label className="input-checkbox">
              <Input
                type="checkbox"
                id="maeDesconhecida"
                name="maeDesconhecida"
                //disabled={desabilitarCampo}
                onClick={handleNomeMaeDesconhecido}
                checked={isCheckedNomeMaeDesconhecido}
                {...formMethods}
              />
              <div>{t('cadastro.forms.labels.unknown_mother_check')}</div>
            </label>
          </>
        )}
        <SelectGenero
          id="genero"
          //disabled={desabilitarCampo}
          label={t('cadastro.forms.labels.gender')}
          {...formMethods}
        />
        <InputCadastro
          className="input-data"
          type="date"
          id="dataNascimento"
          name="dataNascimento"
          label={t('cadastro.forms.labels.birth_date')}
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <div className="container-telefone">
          <InputCadastroComIcone
            type="text"
            className="col-1"
            campoClassName="campo-ddi"
            iconName="ic-adicionar"
            id="ddiMovel"
            name="ddiMovel"
            maxLength="3"
            placeholder="99"
            label={t('cadastro.forms.labels.ddi')}
            {...formMethods}
            onBlur={atribuirDDI}
            //disabled={desabilitarCampo}
          />

          <InputCadastro
            type="text"
            className="col-1"
            campoClassName="campo-ddd"
            id="dddMovel"
            name="dddMovel"
            maxLength="3"
            label={t('cadastro.forms.labels.ddd')}
            placeholder="999"
            {...formMethods}
            onBlur={atribuirDDI}
            //disabled={desabilitarCampo}
          />

          <InputCelularEstrangeiro
            type="tel"
            id="foneMovel"
            name="foneMovel"
            label={t('cadastro.forms.labels.mobile')}
            {...formMethods}
            //disabled={desabilitarCampo}
          />
        </div>
        <InputCadastroComIcone
          type="email"
          id="email"
          name="email"
          label={t('cadastro.forms.labels.email')}
          maxLength="80"
          placeholder="email@email.com"
          iconName="ic-carta"
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputSenha
          id="senha"
          name="senha"
          label={
            t('cadastro.forms.labels.password') +
            ' ' +
            t('cadastro.messages.validation.password_requirements')
          }
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />
        <InputSenha
          id="confirmaSenha"
          name="confirmaSenha"
          label={t('cadastro.forms.labels.confirm_password')}
          placeholder=""
          {...formMethods}
          //disabled={desabilitarCampo}
        />

        <div className="campos">
          <div className="controle">
            {listaNecessidades ? (
              <CheckboxGroup
                //className="checks"
                name="necessidadesEspeciais"
                options={[
                  ...listaNecessidades.map((item) => ({
                    id: item.id,
                    value: item.id,
                    label: item.descricao,
                  })),
                ]}
                label={t('cadastro.forms.labels.special_needs')}
                {...formMethods}
              ></CheckboxGroup>
            ) : (
              <div></div>
            )}
          </div>
        </div>

        <p className="legenda txt-obrigatorios">
          {t('cadastro.forms.labels.required_fields')}
        </p>
        <hr />
        {ddi === '55' ? (
          <div className="receber-token radio-container">
            <p className="">
              {t('cadastro.messages.info.token_registration_method')}
            </p>

            <label className="radio">
              <Input
                type="radio"
                id="E"
                name="meioEnvio"
                value="E"
                checked={meioEnvio === 'E'}
                onChange={handleMeioEnvio}
                //disabled={desabilitarCampo}
                {...formMethods}
              />
              <div className="subtitulo-p">
                {t('cadastro.forms.options.email_option')}
              </div>
            </label>

            <label className="radio">
              <Input
                type="radio"
                id="C"
                name="meioEnvio"
                value="C"
                checked={meioEnvio === 'C'}
                onChange={handleMeioEnvio}
                //disabled="true"
                //disabled={desabilitarCampo}
                {...formMethods}
              />
              <div className="subtitulo-p">
                {t('cadastro.forms.options.mobile_option')}
              </div>
            </label>
          </div>
        ) : (
          <label>
            {' '}
            {t('cadastro.messages.info.token_email_registration', {
              defaultValue:
                'Seu token de confirmação de cadastro será enviado para seu E-mail.',
            })}
          </label>
        )}
        <hr />
        <label className="input-checkbox">
          <Input
            type="checkbox"
            id="termo"
            name="termo"
            checked={isCheckedTermo}
            onChange={handleTermo}
            //disabled={desabilitarCampo}
          />
          <div>
            {t('cadastro.messages.info.privacy_acceptance_read')}&ensp;
            <a
              className="txt-link"
              href="https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-notas-legais"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('cadastro.legal.privacy_policy')}
            </a>
          </div>
        </label>
        <br />
        <div className="btns-row">
          <button
            id="btn-prosseguir"
            type="submit"
            className="btn-pre primario"
            disabled={desabilitarSalvar}
          >
            {t('cadastro.forms.buttons.register')}
          </button>

          <button
            id="btn-limpar"
            type="reset"
            className="btn-txt"
            onClick={handleReset}
          >
            {t('cadastro.forms.buttons.clear')}
          </button>
          <button
            id="btn-voltar"
            type="button"
            className="btn-txt"
            onClick={() => navigate('/login')}
          >
            {t('cadastro.forms.buttons.cancel')}
          </button>
        </div>
      </form>
    </>
  );
};
export default FormCadastroPFEstrangeiro;
